import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager";
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import {clientGET} from 'Core/data/RestApi';

const INIT_STATE = {
  loading: false,
  openImport: false,
  csvFile: null,
  urlFileCsv: null,
  file: null,
  registers: [],
};

const route = "modules/settings/views/driver/components/changeStatus/redux/slice";

export const importDriverAction = createAsyncThunk(
  "settings/driver/components/importDriverAction",
  async (payload, { rejectWithValue }) => {

    const { fileKey, delimiter } = payload;

    try {
      let data = await clientMutation(
        `
            mutation importDrivers ($fileKey: String!, $delimiter: String!) {
                importDrivers (fileKey: $fileKey, delimiter: $delimiter) {
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
      `,
        {
            delimiter,
            fileKey
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (data?.importDrivers) {
        return data;
      } else {
        throw "Error while importing drivers";
      }
    } catch (exc) {
      ExceptionManager(exc, route, "importDriverAction");
      rejectWithValue(exc);
    }
  }
);

export const loadFileCsv = createAsyncThunk(
  "settings/driver/components/loadFileCsv",
  async (payload, { rejectWithValue }) => {
    const { Url } = payload;

    try {
      const result = await clientGET('', {}, Url, false);
      if (result) {
        return { error: false, file: result };
      } else {
        throw "Error while loading CSV file";
      }
    } catch (exc) {
      ExceptionManager(
        exc,
        "modules/settings/views/driver/redux/sagas",
        "loadFileCsv",
        true
      );
      return rejectWithValue({ error: true, file: null });
    }
  }
);

export const getUrlFileAttachment = createAsyncThunk(
  "settings/driver/components/getUrlFileAttachment",
  async (payload, { rejectWithValue }) => {
    const { id } = payload;

    try {
      const data = await clientQuery(
        `query (
          $id: Int!
        ){
          downloadAttachmentUrl: downloadAttachmentUrl(
            id: $id
          )
        }`,
        {
          id
        },
        endpoints.GRAPHQL_GENERAL,
      );

      if (data && data.downloadAttachmentUrl && data.downloadAttachmentUrl) {
        return data.downloadAttachmentUrl;
      } else {
        throw 'There are not url attachment';
      }
    } catch (exc) {
      ExceptionManager(
        exc,
        'modules/settings/views/driver/redux/sagas',
        'getUrlFileAttachment',
      );
      return rejectWithValue(null);
    }
  }
);

export const driverImportDriverSliceRedux = createSlice({
  name: "driver/driverImportDriver",
  initialState: INIT_STATE,
  reducers: {
    resetDriverImportDriverState: (state, action) => {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openDriverImportModal: (state, action) => {
      state.openImport = action.payload;
    },
  },
  extraReducers: (builder) => {
    //importDriver
    builder.addCase(importDriverAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(importDriverAction.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.importDriverResponse = payload;
    });
    builder.addCase(importDriverAction.rejected, (state, { payload }) => {
      state.loading = false;
      state.errorImportDriver = payload;
    });

    //loadFileCsv
    builder.addCase(loadFileCsv.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(loadFileCsv.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.csvFile = payload.file;
      state.csvFileError = payload.error;
    });
    builder.addCase(loadFileCsv.rejected, (state, { payload }) => {
      state.loading = false;
      state.csvFile = payload?.file || null;
      state.csvFileError = payload?.error || true;
    });

    //getUrlFileAttachment
    builder.addCase(getUrlFileAttachment.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getUrlFileAttachment.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.urlFileCsv = payload;
    });
    builder.addCase(getUrlFileAttachment.rejected, (state, { payload }) => {
      state.loading = false;
      state.urlFileCsv = payload;
    });
  },
});

const { actions, reducer } = driverImportDriverSliceRedux;

export const { resetDriverImportDriverState, openDriverImportModal } = actions;

export default reducer;
